import React, {useEffect, useState} from "react";
import {getGradesLists, getGradesInfoById} from "../../service";
import {GradesVisibleData} from "../types";
import FixedTabs from "../../components/fixed-tabs";

function GradesPage() {

    const [lists, setLists] = useState<Array<GradesVisibleData>>([])
    const [active, setActive] = useState<number>(0)
    const [detail, setDetail] = useState<GradesVisibleData>()

    useEffect(() => {
        getGradesLists().then(res => {
            if (res.code === 1) {
                setLists(res.data)
            }
        })
    }, [])

    useEffect(() => {
        if (lists.length > 0) {
            getGradesInfoById({
                gradeId: lists[active].id
            }).then(res => {
                if (res.code === 1) {
                    setDetail(res.data)
                }
            })
        }
    }, [lists, active])

    return <div className="grades-page course-detail">
        {
            lists &&
            <FixedTabs onChange={(active) => setActive(active)} tabs={lists.map(n => n.name)}/>
        }

        {
            detail && <div className="detail">
                <div className="text" dangerouslySetInnerHTML={{__html: detail.description}}/>
            </div>
        }
    </div>
}

export default GradesPage
